module.exports = __webpack_public_path__ + "img/cancel.84a80c0b.svg";